import React, { useEffect, useState } from 'react';
import { Lock, Loader2, Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { useToast } from '../../hooks/use-toast';
import { getSharedJobFields, adminUpdateSharedJobFields } from '../../api';
import RichTextEditor from './RichTextEditor';

export const SHARED_SECTIONS = [
  { key: 'benefits', label: 'Benefits' },
  { key: 'about', label: 'About IronVision' },
  { key: 'eeo', label: 'Equal Opportunity Statement' },
];

export const SharedSectionsCard = () => {
  const { toast } = useToast();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { getSharedJobFields().then(setForm).catch(() => setForm({ benefits: '', about: '', eeo: '' })); }, []);

  const save = async () => {
    setSaving(true);
    try { setForm(await adminUpdateSharedJobFields(form)); toast({ title: 'Shared sections saved', description: 'Every locked job post now shows this text.' }); }
    catch (err) { toast({ title: 'Save failed', description: err?.response?.data?.detail || 'Try again.', variant: 'destructive' }); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="shared-sections-card" className="rounded-xl border border-cyan-400/10 bg-slate-900/30 p-7">
      <div className="flex items-center gap-3 mb-2">
        <Lock className="w-5 h-5 text-cyan-400" />
        <h3 className="text-xl font-semibold text-white">Shared Job Post Sections</h3>
      </div>
      <p className="text-sm text-slate-400 mb-5">Write these once. Every job post with the section locked shows this text, and edits here update all of them. Leave a section empty to hide it.</p>
      {!form ? <div className="text-slate-400 text-sm"><Loader2 className="w-4 h-4 inline animate-spin mr-2" />Loading...</div> : (
        <div className="space-y-4">
          {SHARED_SECTIONS.map(s => (
            <div key={s.key}>
              <Label className="text-slate-300 text-xs mb-1.5 block">{s.label}</Label>
              <RichTextEditor testId={`shared-${s.key}`} value={form[s.key]} onChange={v => setForm(f => ({ ...f, [s.key]: v }))} />
            </div>
          ))}
          <Button data-testid="shared-sections-save-btn" onClick={save} disabled={saving} className="bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-semibold">
            {saving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />} Save shared sections
          </Button>
        </div>
      )}
    </div>
  );
};

export default SharedSectionsCard;
